import React from 'react';

function AboutCard() {
    return(
    <div className="about_me">
        <div className="intro">
            <p>I'm a junior year undergrad student with major in Computer Science, studying in
            Visvesvaraya National
            Institute of Technology India. I love to participate in hackathons as I usually like to
            build new stuff and
            experiment with technologies I know. I have lead 3 hackathons teams so far now and my
            team bagged 2nd position out of 23 teams at my first
            hackathon of MLH Local Hack Day Build 2019
                            </p>
            <p>I strive to learn new technologies with keen interest that can be used to impact community
            as a whole.

                            </p>
        </div>
    </div>
    );
}
export default AboutCard;